import React from 'react';
import Visits from '../components/visits/Visits';
import { hasPermission } from '../components/auth/login/Login';
import { useNavigate } from 'react-router-dom';

const VisitsPage = () => {
    const canReadAvailability = hasPermission('Self-Guided Tours', 'Availability', 'read');
    const canReadAppointment = hasPermission('Self-Guided Tours', 'Appointments', 'read');
    const navigate = useNavigate();

    if (!canReadAppointment && !canReadAvailability) {
        navigate('/no-permission');
    }

    return (
        <div className="outletConainer">
            <Visits />
        </div>
    );
};

export default VisitsPage;
